import React from 'react';
import PropTypes from 'prop-types';
import arrowLeft from '../icons/arrow_left';
import arrowRight from '../icons/arrow_right';
import close from '../icons/close';

const icons = { arrowLeft, arrowRight, close };

const Icon = ({ fill = '#000', type, ...props }) => {
  const icon = icons[type];

  return (
    <span
      className="inline-block"
      dangerouslySetInnerHTML={{ __html: icon(fill) }}
      {...props}
    />
  );
};

Icon.propTypes = {
  fill: PropTypes.string,
  type: PropTypes.oneOf(Object.keys(icons)),
};

export default Icon;
